import { inject, Injectable } from '@angular/core';
import { DataService } from '@core/services/data.service';
import { IDevelopment } from '@core/interfaces';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableService<T extends Object> {}
